import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { Hide } from '../../Helper';
import Step from './Step';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Steps-root_2UUHD"
};
class Steps extends React.Component {
  static defaultProps = {
    active: 1
  };
  getStatus(step, index) {
    if (step.props && step.props.status) {
      return step.props.status;
    }
    if (typeof this.props.status === 'string' && index === this.props.active) {
      return this.props.status;
    }
    if (index === this.props.active) {
      return 'active';
    }
    if (index < this.props.active) {
      return 'completed';
    }
    return 'disabled';
  }
  renderStep = (step, idx) => {
    const index = idx + 1;
    const status = this.getStatus(step, index);
    return /*#__PURE__*/React.cloneElement(step, {
      status,
      index
    });
  };
  renderSteps() {
    return /*#__PURE__*/_jsx(Base, {
      tagName: "ol",
      flex: true,
      flexGrow1: true,
      flexJustifyBetween: true,
      listStyleType: "none",
      margin: "none",
      padding: "none",
      children: React.Children.toArray(this.props.children).map(this.renderStep)
    });
  }
  renderProgess() {
    const {
      active
    } = this.props;
    const total = React.Children.count(this.props.children);
    return /*#__PURE__*/_jsx(Hide, {
      from: "md",
      component: /*#__PURE__*/_jsx(Base, {
        tagName: "span",
        flex: true,
        flexAlignItemsCenter: true,
        children: `${active}/${total}`
      })
    });
  }
  render() {
    const {
      active,
      status,
      children,
      className,
      ...extraProps
    } = this.props;
    return /*#__PURE__*/_jsxs(Base, {
      tagName: "header",
      flex: true,
      className: clsx(styles.root, className),
      ...extraProps,
      children: [this.renderSteps(), this.renderProgess()]
    });
  }
}
export default Steps;